import { Controller } from "@hotwired/stimulus"

// Cascading enable/disable for work log date/time fields:
//   date_from required → unlocks date_to and time_from
//   date_to + time_from set → unlocks time_to
//
// On submit we re-enable the cascaded inputs so their (possibly cleared)
// values are sent. Browsers omit `disabled` inputs from form data, which
// would otherwise leave stale server-side values intact when a user clears
// `date_from` while editing.
export default class extends Controller {
  static targets = ["dateFrom", "dateTo", "timeFrom", "timeTo"]

  connect() {
    this.refresh()
  }

  enableCascadedFields() {
    this.dateToTarget.disabled   = false
    this.timeFromTarget.disabled = false
    this.timeToTarget.disabled   = false
  }

  refresh() {
    const dateFromValue  = this.dateFromTarget.value
    const dateFromFilled = dateFromValue !== ""
    const timeFromFilled = this.timeFromTarget.value !== ""

    if (!dateFromFilled) {
      this.dateToTarget.value = ""
      this.timeFromTarget.value = ""
    }

    if (dateFromFilled) {
      this.dateToTarget.min = dateFromValue
      if (this.dateToTarget.value !== "" && this.dateToTarget.value < dateFromValue) {
        this.dateToTarget.value = dateFromValue
      }
    } else {
      this.dateToTarget.removeAttribute("min")
    }

    this.dateToTarget.disabled   = !dateFromFilled
    this.timeFromTarget.disabled = !dateFromFilled

    const canEnableTimeTo = this.dateToTarget.value !== "" && this.timeFromTarget.value !== ""
    if (!canEnableTimeTo) {
      this.timeToTarget.value = ""
    }
    this.timeToTarget.disabled = !canEnableTimeTo
  }
}
